import { render } from "./OverviewStepComponent.vue?vue&type=template&id=215fc815&ts=true"
import script from "./OverviewStepComponent?vue&type=script&lang=ts"
export * from "./OverviewStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__